import { ReactElement } from 'react';
import Confirm from '../confirm';
import style from './style.module.scss';
import { useStore } from '../../lib/hooks/useStore';
import logger from '../../lib/helpers/logger';
import { PaymentFeeViewServerProps } from '../../lib/typegen/payment-fee-view-server-props';

interface ServiceFeeViewProps {
	amount: number;
	fee: number;
	labels?: PaymentFeeViewServerProps;
	onConfirm: () => void;
	onCancel: () => void;
}

function ServiceFeeView({ amount, fee, labels, onConfirm, onCancel }: ServiceFeeViewProps): ReactElement {
	const titleLabelKey = labels?.titleLabelKey || 'service-fee-description';
	const paymentAmountLabelKey = labels?.paymentAmountLabelKey || 'payment-amount';
	const feeLabelKey = labels?.feeLabelKey || 'fee-amount';
	const confirmMessageLabelKey = labels?.confirmMessageLabelKey || 'continue-prompt';
	const confirmYesLabelKey = labels?.confirmYesLabelKey || 'yes';
	const confirmNoLabelKey = labels?.confirmNoLabelKey || 'no';
	const paymentTotalLabelKey = labels?.paymentTotalLabelKey || 'total-payment';

	const {
		configStore: { getString },
	} = useStore();

	const total = amount + fee;

	const handleYesClick = () => {
		logger.debug.log('ServiceFeeView: Yes button clicked, calling onConfirm');
		onConfirm();
	};

	const handleNoClick = () => {
		logger.debug.log('ServiceFeeView: No button clicked, calling onCancel');
		onCancel();
	};

	return (
		<section className={style['view']}>
			<article className={style['view__description']}>{getString(titleLabelKey).replace('{fee}', fee.toFixed(2))}</article>
			<table className={style['view__table']}>
				<tbody>
					<tr>
						<td>{getString(paymentAmountLabelKey)}:</td>
						<td className={style['view__amount']}>${amount.toFixed(2)}</td>
					</tr>
					<tr>
						<td>{getString(feeLabelKey)}:</td>
						<td className={style['view__amount']}>${fee.toFixed(2)}</td>
					</tr>
					<tr className={style['view__total-row']}>
						<td>{getString(paymentTotalLabelKey)}:</td>
						<td className={style['view__amount']}>${total.toFixed(2)}</td>
					</tr>
				</tbody>
			</table>
			<Confirm
				titleLabel={confirmMessageLabelKey}
				yesButton={{ label: confirmYesLabelKey, value: 'yes', target: '' }}
				noButton={{ label: confirmNoLabelKey, value: 'no', target: '' }}
				yesCallback={handleYesClick}
				noCallback={handleNoClick}
			/>
		</section>
	);
}

export default ServiceFeeView;
